module.exports = __webpack_public_path__ + "712ebee07a8d5c695eb72e1446e6c68c.svg";